import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FeaturesProvider, FeatureRoute } from "@/context/FeaturesContext";
import { Header, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import Comunidad from "@/pages/Comunidad";
import Vidriera from "@/pages/Vidriera";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import ChooseRole from "@/pages/ChooseRole";
import EgresadoPanel from "@/pages/EgresadoPanel";
import EmpresaPanel from "@/pages/EmpresaPanel";
import AdminPanel from "@/pages/AdminPanel";
import Reclamar from "@/pages/Reclamar";
import Cuenta from "@/pages/Cuenta";
import Reset from "@/pages/Reset";
import Terminos from "@/pages/Terminos";
import Privacidad from "@/pages/Privacidad";
import MfaVerify from "@/pages/MfaVerify";
import Empresas from "@/pages/Empresas";

const Shell = ({ children }) => (
  <div className="App">
    <Header />
    <main className="App-main">{children}</main>
    <Footer />
  </div>
);

const Protected = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[var(--brand-primary)] font-heading">Cargando…</div>;
  if (!user) return <Navigate to="/ingresar" replace />;
  if (!user.rol) return <Navigate to="/elegir-rol" replace />;
  if (roles && !roles.includes(user.rol)) return <Navigate to="/" replace />;
  return children;
};

function Router() {
  return (
    <Routes>
      <Route path="/auth/google" element={<AuthCallback />} />
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/comunidad" element={<FeatureRoute feature="comunidad"><Shell><Comunidad /></Shell></FeatureRoute>} />
      <Route path="/vidriera" element={<Shell><Vidriera /></Shell>} />
      <Route path="/ingresar" element={<Shell><Auth /></Shell>} />
      <Route path="/verificacion" element={<Shell><MfaVerify /></Shell>} />
      <Route path="/registro" element={<Shell><Auth /></Shell>} />
      <Route path="/elegir-rol" element={<Shell><ChooseRole /></Shell>} />
      <Route path="/reclamar" element={<Shell><Reclamar /></Shell>} />
      <Route path="/cuenta" element={<Protected><Shell><Cuenta /></Shell></Protected>} />
      <Route path="/empresas" element={<Shell><Empresas /></Shell>} />
      <Route path="/terminos" element={<Shell><Terminos /></Shell>} />
      <Route path="/privacidad" element={<Shell><Privacidad /></Shell>} />
      <Route path="/reset" element={<Shell><Reset /></Shell>} />
      <Route path="/empleos" element={<Navigate to="/egresado?tab=empleos" replace />} />
      <Route path="/egresado" element={<Protected roles={["egresado"]}><Shell><EgresadoPanel /></Shell></Protected>} />
      <Route path="/empresa" element={<Protected roles={["empresa"]}><Shell><EmpresaPanel /></Shell></Protected>} />
      <Route path="/admin" element={<Protected roles={["admin", "super_admin"]}><Shell><AdminPanel /></Shell></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <FeaturesProvider>
        <Toaster position="top-center" offset={72} richColors />
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </FeaturesProvider>
    </AuthProvider>
  );
}
